import { withDisablePortal } from '@hapana/shared/utils/material-ui.util'

/** @type {MuiComponents['MuiMenu']} */
const overwrite = {}

export const MuiMenu = withDisablePortal(overwrite)
